import React from 'react'
import './conversationUpper.scss'

import Button from '../../atoms/button/button'

interface ConversationUpperInter {
    liked: boolean;
    makeLike: () => any;
    onClickBtn: () => any;
    shareAction: () => any;
}

const ConversationUpper = (props: ConversationUpperInter) => {
    let {
        liked,
        makeLike,
        onClickBtn,
        shareAction
    } = props;

    return(
        <div className='a-conversation-upper'>
            <div className='cover'></div>

            <div className='a-conversation-upper__title'>
                <p>¿Qué crees que hay más allá del universo?</p>
            </div>

            <div className='a-conversation-upper__interactive'>
                <Button
                classname='a-conversation-upper__interactive-btn'
                type='button'
                text='COMENTAR'
                isDisabled={false}
                onClickAction={onClickBtn}
                />

                <p
                className={`a-conversation-upper__interactive-like 
                ${!liked ? 'icon-heart1': 'icon-heart'}`}
                onClick={makeLike}
                ></p>

                <p
                className='a-conversation-upper__interactive-share icon-share' 
                onClick={shareAction}
                ></p>
            </div>
        </div>
    )
}

export default ConversationUpper;
